var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "layout personal-employee",
      attrs: { id: "personal-employee" },
    },
    [
      _c("employee-form", { ref: "editEmployee" }),
      _c("candidate-modal", {
        ref: "candidateModal",
        on: { "on-close": _vm.onCandidateSidesheetClose },
      }),
      _c("div", { staticClass: "personal-employee__header" }, [
        _c("div", { staticClass: "personal-employee__header__employee" }, [
          _c(
            "div",
            {
              directives: [{ name: "viewer", rawName: "v-viewer" }],
              staticClass: "personal-employee__header__employee__avatar",
            },
            [
              _c(
                "div",
                { staticClass: "svg-wrapper" },
                [
                  _c("svg-icon", {
                    attrs: { name: "eye", size: 32, color: "white" },
                  }),
                ],
                1
              ),
              _c("img", {
                attrs: {
                  src:
                    _vm.userInfo.photo === null
                      ? _vm.noAvatarImg
                      : _vm.userInfo.photo,
                },
                on: { error: _vm.replaceImageOnErrorLoad },
              }),
            ]
          ),
          _c(
            "div",
            { staticClass: "personal-employee__header__employee__info" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "personal-employee__header__employee__info__fullname",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "personal-employee__header__employee__info__fullname__text",
                    },
                    [_vm._v(" " + _vm._s(_vm.userInfo.name) + " ")]
                  ),
                  _c("c-worksheet-status-icon", {
                    staticClass:
                      "personal-employee__header__employee__info__fullname__worksheet__status only-desktop",
                    attrs: {
                      worksheet: {
                        additional_fields:
                          _vm.userInfo.quest_info.additional_fields,
                        required_fields:
                          _vm.userInfo.quest_info.required_fields,
                        total: _vm.userInfo.quest_info.total,
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass:
                    "personal-employee__header__employee__info__block",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "personal-employee__header__employee__info__filial",
                    },
                    [_vm._v(" " + _vm._s(_vm.userInfo.filial) + " ")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "personal-employee__header__employee__info__position",
                    },
                    [
                      _c(
                        "ul",
                        {
                          staticClass:
                            "personal-employee__header__employee__info__position__names",
                        },
                        _vm._l(_vm.userInfo.posts, function (post, index) {
                          return _c(
                            "li",
                            {
                              key: index,
                              staticClass:
                                "personal-employee__header__employee__info__position__names__item",
                            },
                            [
                              _vm._v(" " + _vm._s(post) + " "),
                              _vm.userInfo !== undefined &&
                              index === 0 &&
                              _vm.userInfo.docsStatus
                                ? _c("c-doc-problems-icon", {
                                    staticClass:
                                      "personal-employee__header__employee__info__position__names__item__icon only-desktop",
                                    attrs: {
                                      "icon-key": "doc-problems-desktop",
                                      data: {
                                        docsTrouble: _vm.userInfo.docsStatus,
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _vm.userInfo !== undefined &&
                              index === 0 &&
                              _vm.userInfo.rankRecommendations
                                ? _c("c-rank-info-icon", {
                                    staticClass:
                                      "personal-employee__header__employee__info__position__names__item__icon only-desktop",
                                    attrs: {
                                      "icon-key": "rank-desktop-2",
                                      data: _vm.userInfo.rankRecommendations,
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "personal-employee__header__employee__info__experience",
                },
                [
                  _vm._v(" Стаж: "),
                  _vm.userInfo.experience.years
                    ? _c("span", [
                        _vm._v(_vm._s(_vm.userInfo.experience.years) + " г"),
                      ])
                    : _vm._e(),
                  _c("span", [
                    _vm._v(
                      " " + _vm._s(_vm.userInfo.experience.month) + " мес"
                    ),
                  ]),
                ]
              ),
            ]
          ),
        ]),
        _c(
          "div",
          { staticClass: "personal-employee__header__buttons" },
          [
            _vm.canViewComment
              ? _c("chat-button", {
                  staticClass: "personal-employee__header__buttons__top",
                  attrs: {
                    entity: "personal_file",
                    "entity-id": _vm.userInfo.workerId,
                    "can-edit": _vm.canEditComment,
                  },
                })
              : _vm._e(),
            _vm.userHavePermissionChangeWorkerStatuses()
              ? _c("c-button", {
                  staticClass: "personal-employee__header__buttons__top",
                  attrs: {
                    size: "small",
                    icon: "edit-worker",
                    tooltip: {
                      text: "Настройки сотрудника",
                    },
                  },
                  on: { click: _vm.toEditWorker },
                })
              : _vm._e(),
            _vm.userInfo.candidateId
              ? _c("c-button", {
                  staticClass: "personal-employee__header__buttons__top",
                  attrs: { size: "small", responsive: true, label: "Кандидат" },
                  on: { click: _vm.openCandidateHistory },
                })
              : _vm._e(),
            _c("c-button", {
              staticClass:
                "personal-employee__header__buttons__to__employees__list",
              attrs: {
                size: "small",
                responsive: true,
                icon: "back",
                type: "with-icon",
                label: "К списку сотрудников",
              },
              on: {
                click: function ($event) {
                  return _vm.$router.push({ name: "employees-list" })
                },
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "personal-employee__tabs" },
        [
          _c("c-tabs", {
            attrs: { items: _vm.tabs.items, "with-routing": "" },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "personal-employee__content" },
        [
          _c("router-view", {
            ref: "route",
            attrs: {
              "user-info": _vm.userInfo,
              "filial-id": _vm.userInfo.filialId,
              "filial-name": _vm.userInfo.filial,
              "worker-full-name": _vm.userInfo.name,
              "filials-permission": _vm.filialsPermission,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }